import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/faq';
import Accordion from '@/components/base/Accordion';

export default function FaqPreview() {
  return (
    <section className="border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.7fr_1.3fr]">
          <div className="lg:sticky lg:top-32 lg:self-start">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-wide text-primary-700">
              <i className="ri-question-answer-line" aria-hidden="true" />
              常见问题
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[28px]">
              关于本站，你可能想知道
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              内容来源、更新方式、线索提供与更正流程，都在这里说清楚。还有疑问可以到问题页继续看，或直接联系我们。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              查看全部问题
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>

          <Accordion items={faqItems.slice(0, 4)} defaultOpenId="faq-1" />
        </div>
      </div>
    </section>
  );
}